export const CACHE_KEY = {
  USER:'kb_login_user',
  TARGET_PATH:'kb_target_path',
  INS_ID:'kb_ins_id',
  DOMAIN:'kb_domain'
}
export const TYPE_FAVLIST = 'favlist'
export const TYPE_COMMENT = 'comment'


export const TYPE_CN_MAP = {'article':"论文",'statistics':"论文","report":"报告",
             'patent':"专利", 'project':"项目", 'book':"专著", 'award':"获奖", 'scienceData':"科学数据",'sciencedata':"科学数据", 'software':"软件著作权"}

export const MOUDLE_MAME = {
  HOME:'机构主页',
  TALENT:'科研学者',
  FRUIT:'科研成果',
  INS:'科研机构',
  ABOUT:'关于我们',
  USER:'个人主页',
  APPLY:'服务申请',
  JOURNAL_SUBMIT:'期刊论文交存',
}
// 'en':'English',
export const SYS_LANG_OPTIONS = {'zh': '中文','en':'English','ru':'Русский язык'}